import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './Snackbar.css';

function Snackbar({ message, isVisible, onDismiss, onUndo, duration = 3000 }) {
  const { t } = useTranslation();

  const handleDismiss = useCallback(() => {
    if (onDismiss) onDismiss();
  }, [onDismiss]);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setTimeout(handleDismiss, duration);
    return () => clearTimeout(timer);
  }, [isVisible, duration, handleDismiss]);

  if (!isVisible) return null;

  return (
    <div className="snackbar" role="status" aria-live="polite">
      <span className="snackbar__message">
        <span className="material-icons snackbar__icon" aria-hidden="true">check_circle</span>
        {message}
      </span>
      {onUndo && (
        <button
          type="button"
          className="snackbar__undo"
          onClick={onUndo}
        >
          {t('cart.undo')}
        </button>
      )}
    </div>
  );
}

export default Snackbar;
